import { makeAutoObservable, runInAction } from 'mobx';

export class AccountPageController {
  currentTab: "profile" | "settings" | "addresses" | "orders" = "profile"

  setCurrentTab(tab: "profile" | "settings" | "addresses" | "orders") {
    runInAction(() => this.currentTab = tab)
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const accountPageController = new AccountPageController();